export const ACCESS_ROLES = [
    { value: 'owner', label: 'Управляющий' },
    { value: 'admin', label: 'Администратор' },
    { value: 'admin_api', label: 'Администратор с API' },
    { value: 'manager', label: 'Менеджер' },
    { value: 'finance', label: 'Финансы' },
    { value: 'viewer', label: 'Просмотр' }
];

export const getAccessRoleLabel = (value, isOwner = false, roles = ACCESS_ROLES) => {
    if (isOwner) return 'Управляющий';
    if (!value) return 'Без доступа';
    const found = roles.find((role) => role.value === value);
    return found?.label || value;
};
